import { notificationSettingsClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import type { UpdateNotificationSettingsBody } from '@octave/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const log = createLogger('useNotificationSettingsActions');

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      organizationId,
      ...body
    }: UpdateNotificationSettingsBody & { organizationId: string }) => {
      const res = await notificationSettingsClient.updateNotificationSettings({
        params: { organizationId },
        body,
      });
      if (res.status !== 200) throw new Error('Failed to update settings');
      return res.body;
    },
    // Each change is saved on the spot, so a success toast per toggle would
    // be noise: only failures are worth interrupting for.
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        ['notificationSettings', variables.organizationId],
        data
      );
    },
    onError: (error) => {
      log.error('Error updating notification settings', error);
      toast.error(
        "Erreur lors de l'enregistrement des paramètres de notification"
      );
    },
  });
}
